/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Institution from './institution';
import InstitutionDetail from './institution-detail';
import InstitutionUpdate from './institution-update';
import InstitutionDeleteDialog from './institution-delete-dialog';

const InstitutionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Institution />} />
    <Route path="new" element={<InstitutionUpdate />} />
    <Route path=":id">
      <Route index element={<InstitutionDetail />} />
      <Route path="edit" element={<InstitutionUpdate />} />
      <Route path="delete" element={<InstitutionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default InstitutionRoutes;
